import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PublicFooterComponent } from 'src/app/modules/public-pages/components/public-footer/public-footer.component';
import { PublicHeaderComponent } from 'src/app/modules/public-pages/components/public-header/public-header.component';

@Component({
  selector: 'au-public-page-layout',
  templateUrl: './public-page-layout.component.html',
  styleUrls: ['./public-page-layout.component.scss'],
  imports: [RouterOutlet, PublicFooterComponent, PublicHeaderComponent],
})
export class PublicPageLayoutComponent {
  constructor() {}
}
